import { graphql } from 'gql.tada';

export const GET_PROGRAMS_CATALOG = graphql(`
    query searchProgramsCatalog(
        $filter: SearchCatalogProgramsFilterInput
        $orderBy: SearchCatalogProgramsOrderByInput
        $pagination: SearchProgramsPaginationInput
    ) {
        programs {
            catalog(filter: $filter, orderBy: $orderBy, pagination: $pagination) {
                count
                limit
                offset
                items {
                    category {
                        id
                        title
                    }
                    files {
                        coverUrl
                    }
                    editorialization {
                        synopsis
                        title
                    }
                    episodesQuantity
                    identifier {
                        id
                        sku
                    }
                    licensesQuantity
                    parent {
                        files {
                            coverUrl
                        }
                        editorialization {
                            title
                        }
                    }
                    production {
                        firstBroadcastDate
                    }
                }
            }
        }
    }
`);

export const GET_PROGRAMS_DASHBOARD = graphql(`
    query searchProgramsDashboard(
        $filter: SearchDashboardProgramsFilterInput
        $orderBy: SearchProgramsOrderByInput
        $pagination: SearchProgramsPaginationInput
    ) {
        programs {
            dashboard(filter: $filter, orderBy: $orderBy, pagination: $pagination) {
                count
                limit
                offset
                items {
                    audioLanguages
                    category {
                        id
                        title
                    }
                    files {
                        coverUrl
                    }
                    duration
                    editorialization {
                        synopsis
                        title
                    }
                    episodesQuantity
                    identifier {
                        id
                        sku
                    }
                    licensesQuantity
                    lifecycle {
                        published
                        validated
                    }
                    parent {
                        files {
                            coverUrl
                        }
                        editorialization {
                            title
                        }
                    }
                    production {
                        firstBroadcastDate
                    }
                }
            }
        }
    }
`);

export const GET_PROGRAMS_ADMIN = graphql(`
    query searchProgramsAdmin(
        $filter: SearchDashboardProgramsFilterInput
        $orderBy: SearchProgramsOrderByInput
        $pagination: SearchProgramsPaginationInput
    ) {
        programs {
            dashboard(filter: $filter, orderBy: $orderBy, pagination: $pagination) {
                count
                limit
                offset
                items {
                    audioLanguages
                    category {
                        id
                        title
                    }
                    files {
                        coverUrl
                    }
                    duration
                    editorialization {
                        synopsis
                        title
                    }
                    episodesQuantity
                    identifier {
                        id
                        sku
                    }
                    licensesQuantity
                    lifecycle {
                        published
                        validated
                    }
                    parent {
                        files {
                            coverUrl
                        }
                        editorialization {
                            title
                        }
                    }
                    production {
                        firstBroadcastDate
                    }
                }
            }
        }
    }
`);

export const GET_PROGRAMS_BACKOFFICE = graphql(`
    query searchProgramsBackoffice(
        $filter: SearchBackofficeProgramsFilterInput
        $orderBy: SearchProgramsOrderByInput
        $pagination: SearchProgramsPaginationInput
    ) {
        programs {
            backoffice(filter: $filter, orderBy: $orderBy, pagination: $pagination) {
                count
                limit
                offset
                items {
                    audioLanguages
                    files {
                        coverUrl
                    }
                    duration
                    editorialization {
                        title
                    }
                    episodesQuantity
                    identifier {
                        id
                        sku
                    }
                    lifecycle {
                        published
                        validated
                    }
                    parent {
                        files {
                            coverUrl
                        }
                    }
                    seller {
                        legalName
                        identifier {
                            id
                        }
                    }
                }
            }
        }
    }
`);

export const GET_EPISODES_CATALOG = graphql(`
    query searchEpisodesCatalog(
        $filter: SearchCatalogProgramsFilterInput
        $orderBy: SearchCatalogProgramsOrderByInput
        $pagination: SearchProgramsPaginationInput
    ) {
        programs {
            catalog(filter: $filter, orderBy: $orderBy, pagination: $pagination) {
                count
                limit
                offset
                items {
                    duration
                    editorialization {
                        title
                    }
                    episodeNumber
                    identifier {
                        id
                        sku
                    }
                    files {
                        masterSubtitleUrl
                        masterTechnicalDetails {
                            videoTrack {
                                quality
                                resolution {
                                    width
                                    height
                                }
                                aspectRatio
                                bitrate
                            }
                            audioTracks {
                                mode
                                sampleRate
                                bitrate
                                languagesList {
                                    durationInSeconds
                                    languageCode
                                    percentage
                                }
                                languageDominant
                            }
                        }
                        masterUrl
                    }
                }
            }
        }
    }
`);

export const GET_EPISODES_DASHBOARD = graphql(`
    query searchEpisodesDashboard(
        $filter: SearchDashboardProgramsFilterInput
        $orderBy: SearchProgramsOrderByInput
        $pagination: SearchProgramsPaginationInput
    ) {
        programs {
            dashboard(filter: $filter, orderBy: $orderBy, pagination: $pagination) {
                count
                limit
                offset
                items {
                    duration
                    editorialization {
                        title
                    }
                    episodeNumber
                    identifier {
                        id
                        sku
                    }
                    files {
                        masterSubtitleUrl
                        masterTechnicalDetails {
                            videoTrack {
                                quality
                                resolution {
                                    width
                                    height
                                }
                                aspectRatio
                                bitrate
                            }
                            audioTracks {
                                mode
                                sampleRate
                                bitrate
                                languagesList {
                                    durationInSeconds
                                    languageCode
                                    percentage
                                }
                                languageDominant
                            }
                        }
                        masterUrl
                    }
                }
            }
        }
    }
`);

export const GET_EPISODES_ADMIN = graphql(`
    query searchEpisodesAdmin(
        $filter: SearchDashboardProgramsFilterInput
        $orderBy: SearchProgramsOrderByInput
        $pagination: SearchProgramsPaginationInput
    ) {
        programs {
            dashboard(filter: $filter, orderBy: $orderBy, pagination: $pagination) {
                count
                limit
                offset
                items {
                    duration
                    editorialization {
                        title
                    }
                    episodeNumber
                    identifier {
                        id
                        sku
                    }
                    files {
                        masterSubtitleUrl
                        masterTechnicalDetails {
                            videoTrack {
                                quality
                                resolution {
                                    width
                                    height
                                }
                                aspectRatio
                                bitrate
                            }
                            audioTracks {
                                mode
                                sampleRate
                                bitrate
                                languagesList {
                                    durationInSeconds
                                    languageCode
                                    percentage
                                }
                                languageDominant
                            }
                        }
                        masterUrl
                    }
                }
            }
        }
    }
`);

export const GET_PROGRAM_CATALOG = graphql(`
    query programCatalog($id: UUID!) {
        program {
            catalog(id: $id) {
                audioLanguages
                category {
                    id
                    title
                }
                files {
                    coverUrl
                    creditRollUrl
                    masterSubtitleUrl
                    masterTechnicalDetails {
                        videoTrack {
                            quality
                            resolution {
                                width
                                height
                            }
                            aspectRatio
                            bitrate
                        }
                        audioTracks {
                            mode
                            sampleRate
                            bitrate
                            languagesList {
                                durationInSeconds
                                languageCode
                                percentage
                            }
                            languageDominant
                        }
                    }
                    masterUrl
                    trailerSubtitleUrl
                    trailerUrl
                }
                duration
                editorialization {
                    keywords
                    synopsis
                    title
                }
                episodeNumber
                episodesQuantity
                genres {
                    id
                    title
                }
                identifier {
                    id
                    sku
                }
                isSegmentable
                licensesQuantity
                lifecycle {
                    rightExclusivity
                }
                parent {
                    audioLanguages
                    files {
                        coverUrl
                    }
                    editorialization {
                        keywords
                        synopsis
                        title
                    }
                    identifier {
                        id
                        sku
                    }
                }
                price
                production {
                    awards
                    casting
                    directors
                    firstBroadcastDate
                    imdb
                    originalLanguage
                    productionCountry
                }
                publicSeller {
                    legalName
                }
            }
        }
    }
`);

export const GET_PROGRAM_DASHBOARD = graphql(`
    query programDashboard($id: UUID!) {
        program {
            dashboard(id: $id) {
                audioLanguages
                category {
                    id
                    title
                }
                files {
                    coverUrl
                    creditRollUrl
                    masterSubtitleUrl
                    masterTechnicalDetails {
                        videoTrack {
                            quality
                            resolution {
                                width
                                height
                            }
                            aspectRatio
                            bitrate
                        }
                        audioTracks {
                            mode
                            sampleRate
                            bitrate
                            languagesList {
                                durationInSeconds
                                languageCode
                                percentage
                            }
                            languageDominant
                        }
                    }
                    masterUrl
                    trailerSubtitleUrl
                    trailerUrl
                }
                duration
                editorialization {
                    keywords
                    synopsis
                    title
                }
                episodeNumber
                episodesQuantity
                excludedCountries {
                    countryCode
                    exclusionType
                }
                genres {
                    id
                    title
                }
                identifier {
                    id
                    sku
                }
                isSegmentable
                lifecycle {
                    published
                    rightExclusivity
                    validated
                }
                parent {
                    audioLanguages
                    files {
                        coverUrl
                    }
                    editorialization {
                        keywords
                        synopsis
                        title
                    }
                    identifier {
                        id
                        sku
                    }
                }
                production {
                    awards
                    casting
                    directors
                    firstBroadcastDate
                    imdb
                    originalLanguage
                    productionCountry
                }
            }
        }
    }
`);

export const GET_PROGRAM_ADMIN = graphql(`
    query programAdmin($id: UUID!) {
        program {
            dashboard(id: $id) {
                audioLanguages
                category {
                    id
                    title
                }
                files {
                    coverUrl
                    creditRollUrl
                    masterSubtitleUrl
                    masterTechnicalDetails {
                        videoTrack {
                            quality
                            resolution {
                                width
                                height
                            }
                            aspectRatio
                            bitrate
                        }
                        audioTracks {
                            mode
                            sampleRate
                            bitrate
                            languagesList {
                                durationInSeconds
                                languageCode
                                percentage
                            }
                            languageDominant
                        }
                    }
                    masterUrl
                    trailerSubtitleUrl
                    trailerUrl
                }
                duration
                editorialization {
                    keywords
                    synopsis
                    title
                }
                episodeNumber
                episodesQuantity
                excludedCountries {
                    countryCode
                    exclusionType
                }
                genres {
                    id
                    title
                }
                identifier {
                    id
                    sku
                }
                isSegmentable
                lifecycle {
                    published
                    rightExclusivity
                    validated
                }
                parent {
                    audioLanguages
                    files {
                        coverUrl
                    }
                    editorialization {
                        keywords
                        synopsis
                        title
                    }
                    identifier {
                        id
                        sku
                    }
                }
                production {
                    awards
                    casting
                    directors
                    firstBroadcastDate
                    imdb
                    originalLanguage
                    productionCountry
                }
            }
        }
    }
`);

export const UPDATE_PROGRAM_DASHBOARD = graphql(`
    mutation updateProgramDashboard($id: UUID!, $input: UpdateProgramInput!) {
        program {
            dashboard {
                update(id: $id, input: $input) {
                    identifier {
                        id
                        sku
                    }
                }
            }
        }
    }
`);

export const DELETE_PROGRAM = graphql(`
    mutation deleteProgram($id: UUID!) {
        program {
            backoffice {
                delete(id: $id) {
                    id
                    success
                }
            }
        }
    }
`);

export const GET_EPISODES_PRICE = graphql(`
    query getEpisodesPrice($id: UUID!, $excludedEpisodeIds: [UUID!]) {
        program {
            catalog(id: $id) {
                episodesPrice(excludedEpisodeIds: $excludedEpisodeIds)
            }
        }
    }
`);
